/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_SessionsInputs */

const zh_learn_sessions = /** @type {(inputs: Learn_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习资源`)
};

const en_learn_sessions = /** @type {(inputs: Learn_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const es_learn_sessions = /** @type {(inputs: Learn_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Learn_SessionsInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_sessions = /** @type {((inputs?: Learn_SessionsInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_SessionsInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_sessions(inputs)
	if (locale === "en") return en_learn_sessions(inputs)
	return es_learn_sessions(inputs)
});